import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseStatus } from 'src/app/shared/enums';
import Swal from 'sweetalert2';
import { BadeLoftService } from '../bade-loft.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css'],
})
export class CallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private _blS: BadeLoftService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params) {
        var code = params['code'];
        var state = params['state'];
        var realmId = params['realmId'];

        this.QBOCallBack(code, state, realmId);
      }
    });
    //TODO:get resopnse from quickbooks callback with query parameter code,state,reamId
    //Read querystring parameter and pass those parameter to badeloft api.
    //Call api //api/QBOConnection/QBOCallBack?code,state,reamid
    //show loading to user while processing on server.
    // sweet alert your connection successfully done
    // once user click on ok button or close sweet alert.
    // once response done redirect to user on connection-status page.
  }
  QBOCallBack(code: any, state: any, realmId: any) {
    try {
      this._blS.QBOCallBack(code, state, realmId).subscribe((response: any) => {
        if (response) {
          if (response.httpStatusCode == ResponseStatus.Success) {
            Swal.fire({
              title: 'Connected',
              text: 'Your connection with Quickbooks Online is successfully done!',
              icon: 'success',
              confirmButtonText: 'Ok',
              confirmButtonColor: '#326c96',
            }).then(() => {
              this._router.navigate(['/bade-loft/connection']);
            });
          } else {
            Swal.fire({
              title: 'Failed',
              text: 'Your connection with Quickbooks Online is failed!',
              icon: 'error',
              confirmButtonText: 'Ok',
              confirmButtonColor: '#326c96',
            }).then(() => {
              this._router.navigate(['/bade-loft/connection']);
            });
          }
        }
      });
    } catch (error) {}
  }
}
